import React, { useState } from "react";
import logo from "../assets/logoblue.png";
import { Link, NavLink } from "react-router-dom";
import ico1 from '../assets/fbico.png'
import ico2 from '../assets/ldnlogo.png'
import ico3 from '../assets/icotwitter.png'

const Navbar = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleNavbar = () => setIsNavbarOpen(!isNavbarOpen);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  return (
    <>
      {/* Top Contact Bar */}
      <div className="bg-gray-500 w-full h-14 relative flex justify-between items-center px-4">
  {/* Left Content */}
  <ul className="flex flex-wrap justify-start list-none p-0 m-0">
    {/* Phone Number */}
    <li className="flex items-center text-left text-lg m-2">
      <a
        href="tel:(111)%20111-1111"
        className="flex items-center text-gray-900 text-base font-normal no-underline transition duration-200"
      >
        <span className="relative flex items-center">
          <svg
            aria-hidden="true"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 mr-1 fill-white transition duration-300"
          >
            <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"></path>
          </svg>
        </span>
        <span className="text-white pl-1 text-base transition duration-300">
          (111) 111-1111
        </span>
      </a>
    </li>

    {/* Email */}
    <li className="flex items-center text-left text-lg m-2">
      <a
        href="https://mail.google.com/mail/?view=cm&fs=1&to=info@axionmbs.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center text-gray-900 text-base font-normal no-underline transition duration-200"
      >
        <span className="relative flex items-center">
          <svg
            aria-hidden="true"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 mr-1 fill-white transition duration-300"
          >
            <path d="M502.3 190.8l-192-160a48 48 0 0 0-60.6 0l-192 160A48 48 0 0 0 32 224v192a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V224a48 48 0 0 0-13.7-33.2zM256 284.3L83.2 160H428.8zm176 139.7H80V224l176 144 176-144z"></path>
          </svg>
        </span>
        <span className="text-white pl-1 text-base transition duration-300">
          info@axionmbs.com
        </span>
      </a>
    </li>
  </ul>

  {/* Right Content - PNG Icons */}
  <div className="flex space-x-4 items-center">
    <img
      src={ico1}
      alt="Icon 1"
      className="w-6 h-6 object-contain cursor-pointer filter invert transition-transform transform hover:scale-110"
    />
    <img
      src={ico2}
      alt="Icon 2"
      className="w-6 h-6 object-contain cursor-pointer filter invert transition-transform transform hover:scale-110"
    />
    <img
      src={ico3}
      alt="Icon 3"
      className="w-6 h-6 object-contain cursor-pointer filter invert transition-transform transform hover:scale-110"
    />
  </div>
</div>


      {/* Main Navigation */}
      <nav className="sticky top-0 bg-slate-100 border-gray-200 dark:bg-gray-900 dark:border-gray-700 z-50">
        <div className="max-w-screen-xl flex items-center justify-between mx-auto py-2 px-4">
          {/* Logo */}
          <a
            href="#"
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <img src={logo} className="h-16" alt="Company Logo" />
          </a>

         {/* Centered Navigation Links */}
<div className="hidden md:flex justify-center flex-1">
  <ul className="flex space-x-8 font-extrabold font-serif text-lg">
    <li>
      <NavLink
        to="/LandingPage"
        className="text-gray-900 hover:text-blue-700 dark:text-white dark:hover:text-blue-500"
      >
        Home
      </NavLink>
    </li>
    <li className="relative">
      <div className="flex items-center space-x-2">
        {/* Wrap 'Services' in a Link for navigation */}
        <NavLink
          to="/Services"
          className="text-gray-900 hover:text-blue-700 dark:text-white dark:hover:text-blue-500"
        >
          Services
        </NavLink>

        {/* Dropdown Toggle Button */}
        <button
          onClick={toggleDropdown}
          className="ml-1 flex items-center text-gray-900 hover:text-blue-700 dark:text-white dark:hover:text-blue-500"
        >
          <svg
            className="w-2.5 h-2.5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>
      </div>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div className="absolute z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44">
          <ul className="py-2 text-sm text-gray-700">
            <li>
              <Link
                to="/Services"
                className="block px-4 py-2 hover:bg-gray-100"
              >
                Dashboard
              </Link>
            </li>
          </ul>
        </div>
      )}
    </li>

    {/* Specialities Link */}
    <li className="ml-4"> {/* Add 'ml-4' for margin-left */}
      <NavLink
        to="/Speciality"
        className="text-gray-900 hover:text-blue-700 dark:text-white dark:hover:text-blue-500"
      >
        Specialities
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/About"
        className="text-gray-900 hover:text-blue-700 dark:text-white dark:hover:text-blue-500"
      >
        About Axion
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/Contact"
        className="button-86 "
      >
        Contact Us
      </NavLink>
    </li>
  </ul>
</div>


          {/* Mobile Menu Toggle */}
          <button
            onClick={toggleNavbar}
            className="md:hidden text-gray-500 hover:bg-gray-100 p-2 rounded-lg"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>

        {/* Mobile Links */}
        {isNavbarOpen && (
          <div className="md:hidden">
            <ul className="flex flex-col items-center space-y-4 py-4">
              <li>
                <NavLink
                  to="/LandingPage"
                  className="text-gray-900 hover:text-blue-700"
                >
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/Services"
                  className="text-gray-900 hover:text-blue-700"
                >
                  Services
                </NavLink>
              </li>
              <li>
              <NavLink
                  to="/Speciality"
                  className="text-gray-900 hover:text-blue-700"
                >
                  Specialities
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/About"
                  className="text-gray-900 hover:text-blue-700"
                >
                  About Axion
                </NavLink>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
